import React from "react";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";
import PasswordChange from "../components/AuthPages/Forgot_Password/PasswordChange";
import {
  authRoutes,
  investigatorRoutes,
  analyticsRoutes,
  manageDataRoute,
  configuration,
  userManagementRoutes,
} from "./routeConstants";
import PageNotFound from "../components/PageNotFound";
// import VisualizationInterface from "../pages/visualization/query_interface/index";
import VisualizationInterface from "../pages/analytics/visualization/Visualization";
import Investigation from "../pages/investigationAnalysis/Investigation/index";
// import Logs from "../pages/administrator/AuditLogs";
import FilesPreview from "../pages/investigationAnalysis/FilesPreview";
import Review from "../pages/investigationAnalysis/review/index";
import ReviewList from "../pages/investigationAnalysis/review/List";
import CopyHistory from "../pages/investigationAnalysis/review/CopyHistory";
import NewLogsDashboard from "../pages/investigationAnalysis/NewAuditLogs/Dashboard";
import TaskStatusWidgetDashboard from "../pages/investigationAnalysis/NewTaskStatus";
import { useLocation } from "react-router-dom";
import Batches from "../pages/analytics/batches/Batches";
import AuditLogs from "../pages/analytics/auditTrail/index";
import Limit from "../pages/analytics/limit/Limit";
import Process from "../pages/analytics/process/Process";
import VisualizationList from "../pages/analytics/visualization/visualizationList";
import HomePage from "../pages/analytics/home/HomePage";
import ReportsPage from "../pages/analytics/reports/ReportsDashboard";
import NewReport from "../pages/analytics/reports/NewReport";
import ViewReport from "../pages/analytics/reports/ViewReport";
import OktaLogin from "../pages/okta/OktaLogin";
import UopList from "../pages/configuration/uop/UopList";
import ProductLIst from "../pages/configuration/product/ProdcutList";
import SiteList from "../pages/configuration/site/SiteList";
import ParamterList from "../pages/configuration/parameter/ParamterList";
import AuditList from "../pages/configuration/audit/AuditList";
import GenealogyReportListTable from "../pages/analytics/genealogy/list/GenealogyReportListTable";
import CreateGenealogyReport from "../pages/analytics/genealogy/newReport/CreateGenealogyReport";
import GenealogyReport from "../pages/analytics/genealogy/report/GenealogyReport";
// import Analytics from "../pages/analytics";
import Dashboard from "../pages/analytics/dashboard/Dashboard";
import {
  UserList,
  EditUser,
  AccessGroupList,
  AccessGroupForm,
  UserManagementAuditTrail,
} from "../pages/userManagement/UserManagement";
import AuditTrailList from "../pages/configuration/configAudit/AuditTrailList";
import VersionHistory from "../pages/configuration/configAudit/VersionHistory";
import {
  hasAnyModulePermission,
  hasAnyPermission,
  hasPermission,
} from "../utils/permissions";
import {
  BATCHES_PERMISSIONS,
  CONFIGURATION_PERMISSIONS,
  DASHBOARD_PERMISSIONS,
  GENEALOGY_PERMISSIONS,
  FULL_ACCESS_PERMISSIONS,
  LIMITS_PERMISSIONS,
  MANAGE_DATA_MODULE,
  MANAGE_DATA_PERMISSIONS,
  PERMISSION_MODULES,
  PROCESS_PERMISSIONS,
  REPORT_PERMISSIONS,
  USER_ACCESS_MANAGEMENT_PERMISSIONS,
  VISUALIZATION_PERMISSIONS,
} from "../constants/permissions";

const AuthRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      <Route
        path={`/${authRoutes?.forgotPassword}/:token?`}
        element={<PasswordChange navigate={navigate} />}
      />
      <Route path={`/*`} element={<PageNotFound />} />
      <Route path={`/${authRoutes.oktaLogin}`} element={<OktaLogin />} />
    </Routes>
  );
};

// const VisualizationRoutes = () => (
//   <Routes>
//     <Route
//       path={`/${analyticsRoutes?.visualizationInterface}`}
//       element={<VisualizationInterface />}
//     />
//   </Routes>
// );

const AnalyticsRoutes = () => (
  <Routes>
    <Route
      path={`/${analyticsRoutes?.visualizationInterface}`}
      element={<VisualizationInterface />}
    />

    {/* <Route path={`/${analyticsRoutes?.analytics}`} element={<Analytics />} /> */}
  </Routes>
);

const SrmChartRoute = () => {
  const location = useLocation();
  const { mode: routeMode } = useParams();
  const mode = location.state?.mode || routeMode || "create";
  const permissionByMode = {
    view: VISUALIZATION_PERMISSIONS.OPEN_CHART,
    edit: VISUALIZATION_PERMISSIONS.EDIT_CHART,
    create: VISUALIZATION_PERMISSIONS.CREATE_NEW_CHART,
  };
  return hasPermission(
    PERMISSION_MODULES.VISUALIZATION,
    permissionByMode[mode] || VISUALIZATION_PERMISSIONS.OPEN_CHART,
  ) ? (
    <VisualizationInterface />
  ) : (
    <PageNotFound />
  );
};

const PermissionRoute = ({ moduleName, permissions, children }) =>
  hasAnyPermission(moduleName, permissions) ? children : <PageNotFound />;

const ReportEditorRoute = () => {
  const location = useLocation();
  const { reprt, mode: routeMode } = useParams();
  const mode =
    location.state?.mode ||
    routeMode ||
    (reprt?.includes("edit") ? "edit" : "create");
  const permission =
    mode === "edit"
      ? REPORT_PERMISSIONS.EDIT_DRAFT_REPORT
      : REPORT_PERMISSIONS.CREATE_NEW_REPORT;

  return hasPermission(PERMISSION_MODULES.REPORT, permission) ? (
    <NewReport />
  ) : (
    <PageNotFound />
  );
};

const GenealogyEditorRoute = () => {
  const location = useLocation();
  const { mode } = useParams();
  const permission =
    mode === "create"
      ? GENEALOGY_PERMISSIONS.CREATE_NEW_REPORT
      : location.state?.status === "Draft"
        ? GENEALOGY_PERMISSIONS.EDIT_DRAFT_REPORT
        : GENEALOGY_PERMISSIONS.VIEW_SAVED_REPORT;

  return hasPermission(PERMISSION_MODULES.GENEALOGY, permission) ? (
    <CreateGenealogyReport />
  ) : (
    <PageNotFound />
  );
};

const InvestigatorRoutes = () => (
  <>
    <Route
      path={`/${investigatorRoutes?.investigationAnalysis}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.SEARCH_AND_INVESTIGATE}
          permissions={[FULL_ACCESS_PERMISSIONS.FULL_ACCESS]}
        >
          <Investigation />
        </PermissionRoute>
      }
    />

    <Route
      path={`/${investigatorRoutes?.logs}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.AUDIT_TRAIL}
          permissions={[FULL_ACCESS_PERMISSIONS.FULL_ACCESS]}
        >
          <NewLogsDashboard />
        </PermissionRoute>
      }
    />

    <Route
      path={`/${investigatorRoutes?.taskStatus}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.TASK_STATUS}
          permissions={[FULL_ACCESS_PERMISSIONS.FULL_ACCESS]}
        >
          <TaskStatusWidgetDashboard />
        </PermissionRoute>
      }
    />

    <Route
      path={`/${investigatorRoutes?.filesPreview}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.DATA_PREVIEW}
          permissions={[FULL_ACCESS_PERMISSIONS.FULL_ACCESS]}
        >
          <FilesPreview />
        </PermissionRoute>
      }
    />
    {/* <Route path={`/${investigatorRoutes?.review}`} element={<Review />} /> */}

    {hasPermission(
      PERMISSION_MODULES.VISUALIZATION,
      VISUALIZATION_PERMISSIONS.VIEW_CHART_LIST,
    ) && (
      <Route
        path={`/${analyticsRoutes?.visualizationInterface}`}
        element={<VisualizationList />}
      />
    )}

    <Route
      // path={`${analyticsRoutes?.visualizationInterface}/charts/:chartType/:mode?`}
      path={`${analyticsRoutes?.visualizationInterface}/charts/:mode?`}
      element={<SrmChartRoute />}
    />

    {/* <Route path={`/${analyticsRoutes?.analytics}`} element={<Analytics />} /> */}

    {/* <Route path="/" element={<Navigate to="/analytics/1/reports" />} /> */}
    <Route
      path={`/${manageDataRoute.reviewList}`}
      element={
        <PermissionRoute
          moduleName={MANAGE_DATA_MODULE}
          permissions={[MANAGE_DATA_PERMISSIONS.VIEW_BATCH_LIST]}
        >
          <ReviewList />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${manageDataRoute.reviewBatches}`}
      element={
        <PermissionRoute
          moduleName={MANAGE_DATA_MODULE}
          permissions={[MANAGE_DATA_PERMISSIONS.VIEW_BATCH_LIST]}
        >
          <Review />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${manageDataRoute.copyHistory}`}
      element={
        <PermissionRoute
          moduleName={MANAGE_DATA_MODULE}
          permissions={[MANAGE_DATA_PERMISSIONS.VIEW_COPIED_BATCHES]}
        >
          <CopyHistory />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes.analytics}/*`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.REPORT}
          permissions={[REPORT_PERMISSIONS.VIEW_REPORT_LIST]}
        >
          <ReportsPage />
        </PermissionRoute>
      }
    />
    {/* <Route path={`/${analyticsRoutes.newReport}/*`} element={<NewReport />} /> */}
    <Route
      path={`${analyticsRoutes?.reports}/:reprt/:mode?`}
      element={<ReportEditorRoute />}
    />
    <Route
      path={`/${analyticsRoutes?.process}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.PROCESS}
          permissions={[PROCESS_PERMISSIONS.VIEW_PARAMETER_LIST]}
        >
          <Process />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes?.limit}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.LIMITS}
          permissions={[LIMITS_PERMISSIONS.VIEW_LIMITS_LIST]}
        >
          <Limit />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes.batches}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.BATCHES}
          permissions={[
            BATCHES_PERMISSIONS.VIEW_BATCH_LIST,
            BATCHES_PERMISSIONS.PARTIAL_DATA_TAB,
          ]}
        >
          <Batches />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes.auditTrail}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.LIMITS}
          permissions={[LIMITS_PERMISSIONS.AUDIT_TRAIL]}
        >
          <AuditLogs />
        </PermissionRoute>
      }
    />
    {/* <Route
      path={`/analytics/:productId/visualization/:chartType?`}
      element={<VisualizationInterface />}
    /> */}
    <Route
      path={`/${analyticsRoutes.viewReport}/*`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.REPORT}
          permissions={[REPORT_PERMISSIONS.VIEW_REPORT_LIST]}
        >
          <ViewReport />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes.genealogy}/`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.GENEALOGY}
          permissions={[GENEALOGY_PERMISSIONS.VIEW_REPORT_LIST]}
        >
          <GenealogyReportListTable />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes.genealogy}/:mode`}
      element={<GenealogyEditorRoute />}
    />
    <Route
      path={`/${analyticsRoutes.genealogyReport}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.GENEALOGY}
          permissions={[GENEALOGY_PERMISSIONS.VIEW_SAVED_REPORT]}
        >
          <GenealogyReport />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${analyticsRoutes.dashboard}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.DASHBOARD}
          permissions={[DASHBOARD_PERMISSIONS.ACCESS_DASHBOARD]}
        >
          <Dashboard />
        </PermissionRoute>
      }
    />
  </>
);

const ConfigurationRoutes = () => {
  const canAccess = (...permissions) =>
    hasAnyPermission(PERMISSION_MODULES.CONFIGURATION, permissions);
  const canAccessProduct = canAccess(
    CONFIGURATION_PERMISSIONS.VIEW_PRODUCT_LIST,
    CONFIGURATION_PERMISSIONS.ADD_PRODUCT,
    CONFIGURATION_PERMISSIONS.UPDATE_PRODUCT,
    CONFIGURATION_PERMISSIONS.APPROVE_PRODUCT,
  );
  const canAccessSite = canAccess(
    CONFIGURATION_PERMISSIONS.VIEW_MANUFACTURING_SITE_LIST,
    CONFIGURATION_PERMISSIONS.ADD_MANUFACTURING_SITE,
    CONFIGURATION_PERMISSIONS.UPDATE_MANUFACTURING_SITE,
    CONFIGURATION_PERMISSIONS.APPROVE_MANUFACTURING_SITE,
  );
  const canAccessUop = canAccess(
    CONFIGURATION_PERMISSIONS.VIEW_UNIT_OPERATION_LIST,
    CONFIGURATION_PERMISSIONS.ADD_UNIT_OPERATION,
    CONFIGURATION_PERMISSIONS.UPDATE_UNIT_OPERATION,
    CONFIGURATION_PERMISSIONS.APPROVE_UNIT_OPERATION,
  );
  const canAccessParameter = canAccess(
    CONFIGURATION_PERMISSIONS.VIEW_PARAMETER_LIST,
    CONFIGURATION_PERMISSIONS.ADD_PARAMETER,
    CONFIGURATION_PERMISSIONS.UPDATE_PARAMETER,
    CONFIGURATION_PERMISSIONS.DELETE_PARAMETER,
    CONFIGURATION_PERMISSIONS.RESTORE_PARAMETER,
    CONFIGURATION_PERMISSIONS.APPROVE_PARAMETER,
    CONFIGURATION_PERMISSIONS.REORDER_PARAMETERS,
    CONFIGURATION_PERMISSIONS.ADD_PARAMETER_PHASE,
    CONFIGURATION_PERMISSIONS.ADD_PARAMETER_TABLE,
    CONFIGURATION_PERMISSIONS.DELETE_PARAMETER_PHASE,
    CONFIGURATION_PERMISSIONS.DELETE_PARAMETER_TABLE,
  );
  const canAccessAudit = canAccess(CONFIGURATION_PERMISSIONS.AUDIT_TRAIL);

  return (
    <>
      {canAccessProduct && (
        <Route
          path={`/${configuration?.productList}`}
          element={<ProductLIst />}
        />
      )}
      {canAccessUop && (
        <Route path={`/${configuration?.uopList}`} element={<UopList />} />
      )}
      {canAccessSite && (
        <Route path={`/${configuration?.siteList}`} element={<SiteList />} />
      )}
      {canAccessParameter && (
        <Route
          path={`/${configuration?.paramterList}`}
          element={<ParamterList />}
        />
      )}
      {canAccessAudit && (
        <Route path={`/${configuration?.auditList}`} element={<AuditList />} />
      )}
      {canAccessAudit && (
        <Route
          path={`/${configuration?.configAuditTrail}`}
          element={<AuditTrailList />}
        />
      )}
      {canAccessAudit && (
        <Route
          path={`/${configuration?.versionHistory}`}
          element={<VersionHistory />}
        />
      )}
    </>
  );
};
const UserManagementRoutes = () => (
  <>
    <Route
      path={`/${userManagementRoutes.users}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.USER_ACCESS_MANAGEMENT}
          permissions={[USER_ACCESS_MANAGEMENT_PERMISSIONS.VIEW_USER_LIST]}
        >
          <UserList />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${userManagementRoutes.editUser}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.USER_ACCESS_MANAGEMENT}
          permissions={[
            USER_ACCESS_MANAGEMENT_PERMISSIONS.EDIT_USER,
            USER_ACCESS_MANAGEMENT_PERMISSIONS.UPDATE_USER_STATUS,
          ]}
        >
          <EditUser />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${userManagementRoutes.accessGroups}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.USER_ACCESS_MANAGEMENT}
          permissions={[
            USER_ACCESS_MANAGEMENT_PERMISSIONS.VIEW_ACCESS_GROUP_LIST,
          ]}
        >
          <AccessGroupList />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${userManagementRoutes.auditTrail}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.USER_ACCESS_MANAGEMENT}
          permissions={[USER_ACCESS_MANAGEMENT_PERMISSIONS.VIEW_AUDIT_TRAIL]}
        >
          <UserManagementAuditTrail />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${userManagementRoutes.createAccessGroup}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.USER_ACCESS_MANAGEMENT}
          permissions={[USER_ACCESS_MANAGEMENT_PERMISSIONS.CREATE_ACCESS_GROUP]}
        >
          <AccessGroupForm />
        </PermissionRoute>
      }
    />
    <Route
      path={`/${userManagementRoutes.editAccessGroup}`}
      element={
        <PermissionRoute
          moduleName={PERMISSION_MODULES.USER_ACCESS_MANAGEMENT}
          permissions={[
            USER_ACCESS_MANAGEMENT_PERMISSIONS.EDIT_ACCESS_GROUP,
            USER_ACCESS_MANAGEMENT_PERMISSIONS.UPDATE_ACCESS_GROUP_STATUS,
            USER_ACCESS_MANAGEMENT_PERMISSIONS.UPDATE_ACCESS_GROUP_PERMISSIONS,
          ]}
        >
          <AccessGroupForm />
        </PermissionRoute>
      }
    />
  </>
);

const RoutesChild = () => {
  const location = useLocation();

  if (
    location.pathname === `/${authRoutes.changePassword}` ||
    location.pathname === `/${authRoutes.oktaLogin}` ||
    location.pathname.startsWith(`/${authRoutes.forgotPassword}`)
  ) {
    return <AuthRoutes />;
  }
  const canViewConfiguration = hasAnyModulePermission(
    PERMISSION_MODULES.CONFIGURATION,
  );
  return (
    <Routes>
      {InvestigatorRoutes()}
      {canViewConfiguration && ConfigurationRoutes()}
      {UserManagementRoutes()}
      <Route path={`/*`} element={<PageNotFound />} />
    </Routes>
  );
};

export default RoutesChild;
